/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormCheckboxFieldComponent from "@Components/UI/Forms/Field/Checkbox";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import {REGISTER_FORM_STEP_TYPE, RegisterFormErrorsInterface} from "@UIPages/NotAuthenticated/Register";
import UserRegistrationRegulationComponent from "@UIPages/NotAuthenticated/Register/Steps/Step3/Regulation";
import {useDispatch} from "react-redux";
import ApplicationApiContext from "@Contexts/Api";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";

type RegisterFormStep3Props = {
    forwardRef?: React.ForwardedRef<any> | null;
    registerFormStep: REGISTER_FORM_STEP_TYPE, registerFormStepHandler(step: number, final?: boolean): void;
    registerFormErrors: RegisterFormErrorsInterface,
    formUserRegulations: any;
    formUserRegulationsHandler: any;
    formUserRegulationsAcceptedStatus: boolean; formUserRegulationsAcceptedStatusHandler(status: boolean): void;
    formUserPrivacyAcceptedStatus: boolean; formUserPrivacyAcceptedStatusHandler(status: boolean): void;
    formUserGeneratedID: string;
};


export const RegisterFormStep3Component: React.FC<RegisterFormStep3Props> = ({
    forwardRef,
    registerFormStep, registerFormStepHandler,
    registerFormErrors,
    formUserRegulations, formUserRegulationsHandler, formUserGeneratedID,
    formUserRegulationsAcceptedStatus, formUserRegulationsAcceptedStatusHandler,
    formUserPrivacyAcceptedStatus, formUserPrivacyAcceptedStatusHandler
}): JSX.Element => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const [regulationsAcceptations, setRegulationsAcceptations] = useState<any>(
        Object.fromEntries(formUserRegulations.map((reg: any, i: number) => [i, false]))
    );

    const allRegulationsAcceptedStatus: boolean = !!(Object.values(regulationsAcceptations).filter((r: any) => !!r).length);

    useEffect(() => {
        formUserRegulationsAcceptedStatusHandler(allRegulationsAcceptedStatus);
    }, [allRegulationsAcceptedStatus]);


    const Regulations = formUserRegulations.map((regulation: any, i: number) =>
        <UserRegistrationRegulationComponent
            key={i}
            index={i}
            formUserGeneratedID={formUserGeneratedID}
            regulationData={regulation}
            regulationsAcceptations={regulationsAcceptations}
            regulationsAcceptationsHandler={setRegulationsAcceptations}
        />
    );


    return (
        <FormFieldsGroupComponent forwardRef={forwardRef} cssClasses={registerFormStep !== 3 ? "disabled" : ""}>

            <FormFieldsGroupFieldsComponent>

                {Regulations}

                {registerFormErrors?.formUserRegulations &&
                <ErrorMessageComponent messageText={registerFormErrors?.formUserRegulations} />
                }

            </FormFieldsGroupFieldsComponent>

            <>
                {registerFormStep === 3 &&
		        <DefaultFormButton
			        buttonText={`Dalej`}
			        clickHandler={() => registerFormStepHandler(4)}
			        controlId={`register-form-user-step3-submit`}
			        disabled={!!REST_API_REQUEST_STATUS}
			        cssClasses={`register-form-user-step-submit`}
		        />
                }
            </>

        </FormFieldsGroupComponent>
    );

};


export default RegisterFormStep3Component;
